export const OperationStatus = {
    Running: 'Running',
    Succeeded: 'Succeeded',
    Canceled: 'Canceled',
    Failed: 'Failed',
};
export default OperationStatus;
